import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { LocationStrategy, HashLocationStrategy, DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { IconModule, IconSetModule, IconSetService } from '@coreui/icons-angular';

import { registerLocaleData } from '@angular/common';
import * as fr from '@angular/common/locales/fr';
import { CKEditorModule } from 'ckeditor4-angular';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';
import {LoginComponent} from './views/auth/login/login.component';
import {RegisterComponent} from './views/auth/register/register.component';
import {ForgetPasswordComponent} from './views/auth/forget-password/forget-password.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { SearchFilterPipe } from './search-filter.pipe';
import {AuthInterceptorService} from '../services/AuthInterceptorService';
import {NgImageFullscreenViewModule} from "ng-image-fullscreen-view";
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import {MessagesErrorsComponent} from "./views/error/messages-errors/messages-errors.component";
import {ErrorMessagesComponent} from "./views/error/error-messages/error-messages.component";
import { CommercialComponent } from './views/admin/commercial/commercial.component';
import { CommerciauxComponent } from './views/admin/commerciaux/commerciaux.component';
import { CommissionComponent } from './views/admin/commission/commission.component';
import { NewletterComponent } from './views/admin/newletter/newletter.component';
import { ProfilComponent } from './views/admin/profil/profil.component';
import { ReversementEffectuesComponent } from './views/admin/reversement-effectues/reversement-effectues.component';
import { ReversementEncoursComponent } from './views/admin/reversement-encours/reversement-encours.component';
import { TransactionComponent } from './views/admin/transaction/transaction.component';
import { UserComponent } from './views/admin/user/user.component';
import { SellerComponent } from './views/admin/seller/seller.component';
import {NgxDatatableModule} from "@tusharghoshbd/ngx-datatable";
import {BsModalService, ModalModule} from "ngx-bootstrap/modal";
import { SellerReversementsComponent } from './views/admin/seller-reversements/seller-reversements.component';
import {UserDetailsComponent} from "./views/admin/user-details/user-details.component";
import { TransactionsComponent } from './views/admin/transactions/transactions.component';
import {UrlService} from "../services/url.service";
import { ErrorMessageComponent } from './views/validators/error-message/error-message.component';
import {SortByColumnPipe} from "./pipe/sortByColumn";
import { CommandeComponent } from './views/admin/commande/commande.component';
import { GiftcardComponent } from './views/admin/giftcard/giftcard.component';
import { CategorieComponent } from './views/admin/categorie/categorie.component';
import { ArticleComponent } from './views/admin/article/article.component';
import { PhotosComponent } from './views/admin/article/photos/photos.component';
import {AuditComponent} from "./views/admin/audit/audit.component";
import { OrangeComponent } from './views/admin/orange/orange.component';
import { KahpooComponent } from './views/admin/kahpoo/kahpoo.component';
import { FaqComponent } from './views/admin/faq/faq.component';
import { ParrainageComponent } from './views/admin/parrainage/parrainage.component';
import { FilleuleComponent } from './views/admin/filleule/filleule.component';
import { SponsorshipDetailsComponent } from './views/admin/sponsorship-details/sponsorship-details.component';
import { CityComponent } from './views/admin/localisations/city/city.component';
import { DistrictComponent } from './views/admin/localisations/district/district.component';
import { StreetComponent } from './views/admin/localisations/street/street.component';
import { AreaComponent } from './views/admin/localisations/area/area.component';
import { TripeExpenseComponent } from './views/admin/localisations/tripe-expense/tripe-expense.component';
import { ZoneComponent } from './views/admin/localisations/zone/zone.component';
import { CountryComponent } from './views/admin/localisations/country/country.component';
import { NotesComponent } from './views/admin/notes/notes.component';
import { ReplyMessageComponent } from './views/admin/reply-message/reply-message.component';
import { ChatNotificationComponent } from './views/admin/chat-notification/chat-notification.component';
import { PublicationsComponent } from './views/admin/publications/publications.component';
import {NgxPaginationModule} from "ngx-pagination";
import { KahpooShopComponent } from './views/admin/kahpoo-shop/kahpoo-shop.component';
import {MailComponent} from "./views/admin/mail/mail.component";
import {ShortenTextPipe} from "./views/admin/pipes/shorten-text.pipe";
import { CommercialClientsComponent } from './views/admin/commercial-clients/commercial-clients.component';
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {ClipboardModule} from "@angular/cdk/clipboard";
import { SessionComponent } from './views/admin/session/session.component';
import {PublicationsComponent2} from "./views/admin/publications2/publications2.component";
import { OrderItemComponent } from './views/admin/order-item/order-item.component';
import { CharacteristicsComponent } from './views/admin/shop/characteristics/characteristics.component';
import { CategorieShopComponent } from './views/admin/shop/categorie-shop/categorie-shop.component';
import { DomainComponent } from './views/admin/domain/domain.component';
import { SubCategoryComponent } from './views/admin/sub-category/sub-category.component';
import { GiftcardPublishedComponent } from './views/admin/kahpoo-shop/giftcard-published/giftcard-published.component';
import { PromotionComponent } from './views/admin/kahpoo-shop/promotion/promotion.component';
import { PromotionOfferComponent } from './views/admin/kahpoo-shop/promotion-offer/promotion-offer.component';
import { PromotionOfferActiveComponent } from './views/admin/kahpoo-shop/promotion-offer-active/promotion-offer-active.component';
import { OfferTypeComponent } from './views/admin/kahpoo-shop/offer-type/offer-type.component';
import { ReservationComponent } from './views/admin/reservation/reservation.component';
import { PostPromoteComponent } from './views/admin/kahpoo-shop/post-promote/post-promote.component';
import { AddPromoteComponent } from './views/admin/kahpoo-shop/post-promote/add-promote/add-promote.component';
import { EditPromoteComponent } from './views/admin/kahpoo-shop/post-promote/edit-promote/edit-promote.component';
import { PassComponent } from './views/admin/kahpoo-shop/pass/pass.component';
import { AddPassComponent } from './views/admin/kahpoo-shop/pass/add-pass/add-pass.component';
import { PassPublishedComponent } from './views/admin/kahpoo-shop/pass/pass-published/pass-published.component';
import { ListPassUserComponent } from './views/admin/kahpoo-shop/pass/list-pass-user/list-pass-user.component';
import { ListShopComponent } from './views/admin/shop/list-shop/list-shop.component';
import { ListProductComponent } from './views/admin/shop/list-shop/list-product/list-product.component';
import { ListServiceComponent } from './views/admin/shop/list-shop/list-service/list-service.component';
import { EmployeOfferComponent } from './views/admin/kahpoo-shop/employe-offer/employe-offer.component';
import { AppliedUserComponent } from './views/admin/kahpoo-shop/employe-offer/applied-user/applied-user.component';
import { EmployeOfferPublishedComponent } from './views/admin/kahpoo-shop/employe-offer/employe-offer-published/employe-offer-published.component';
import { KahpooEmployeOfferComponent } from './views/admin/kahpoo-shop/employe-offer/kahpoo-employe-offer/kahpoo-employe-offer.component';
import { EditPassComponent } from './views/admin/kahpoo-shop/pass/edit-pass/edit-pass.component';
import { VarianteComponent } from './views/admin/shop/list-shop/list-product/variante/variante.component';
import { ErrorMessageEditComponent } from './views/error/error-message-edit/error-message-edit.component';
import { WaveTransactionsComponent } from './views/admin/wave/wave-transactions/wave-transactions.component';
import { StatJobApplyComponent } from './views/chart/stat-job-apply/stat-job-apply.component';
import { DetailPostComponent } from './views/chart/detail-post/detail-post.component';
import { KeysPipe } from './views/validators/KeysPipe';
import { StatByCategoryComponent } from './views/chart/stat-by-category/stat-by-category.component';
import { LikedPostComponent } from './views/chart/liked-post/liked-post.component';
import { AllPromotionsOfferActiveComponent } from './views/admin/kahpoo-shop/all-promotions-offer-active/all-promotions-offer-active.component';
import { PrivateSpaceComponent } from './views/admin/espace-prive/private-space/private-space.component';
import { CustomerSpaceComponent } from './views/admin/espace-prive/customer-space/customer-space.component';
import { PostPrivateSpaceComponent } from './views/admin/espace-prive/post-private-space/post-private-space.component';
import { VariantPrivateSpaceComponent } from './views/admin/espace-prive/variant-private-space/variant-private-space.component';
import { UsersWithSoldProductsComponent } from './views/admin/users-with-sold-products/users-with-sold-products.component';
import { UsersWithSoldProductsDetailsComponent } from './views/admin/users-with-sold-products-details/users-with-sold-products-details.component';
import { UserNewVersionComponent } from './views/admin/user-new-version/user-new-version.component';
import { UpdateSubCategoryComponent } from './views/admin/sub-category/update-sub-category/update-sub-category.component';
import { DelegationComponent } from './views/admin/delegation/delegation.component';

@NgModule({

  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    LoginComponent,
    RegisterComponent,
    ForgetPasswordComponent,
    SearchFilterPipe,
    MessagesErrorsComponent,
    ErrorMessagesComponent,
    CommercialComponent,
    CommerciauxComponent,
    CommissionComponent,
    NewletterComponent,
    ProfilComponent,
    ReversementEffectuesComponent,
    ReversementEncoursComponent,
    TransactionComponent,
    UserComponent,
    SellerComponent,
    SellerReversementsComponent,
    UserDetailsComponent,
    TransactionsComponent,
    ErrorMessageComponent,
    SortByColumnPipe,
    CommandeComponent,
    GiftcardComponent,
    CategorieComponent,
    ArticleComponent,
    PhotosComponent,
    AuditComponent,
    OrangeComponent,
    KahpooComponent,
    FaqComponent,
    ParrainageComponent,
    FilleuleComponent,
    SponsorshipDetailsComponent,
    CountryComponent,
    CityComponent,
    DistrictComponent,
    StreetComponent,
    AreaComponent,
    TripeExpenseComponent,
    ZoneComponent,
    NotesComponent,
    ReplyMessageComponent,
    ChatNotificationComponent,
    PublicationsComponent,
    KahpooShopComponent,
    MailComponent,
    ShortenTextPipe,
    CommercialClientsComponent,
    SessionComponent,
    PublicationsComponent2,
    OrderItemComponent,
    CharacteristicsComponent,
    CategorieShopComponent,
    DomainComponent,
    SubCategoryComponent,
    GiftcardPublishedComponent,
    PromotionComponent,
    PromotionOfferComponent,
    PromotionOfferActiveComponent,
    OfferTypeComponent,
    ReservationComponent,
    PostPromoteComponent,
    AddPromoteComponent,
    EditPromoteComponent,
    PassComponent,
    AddPassComponent,
    PassPublishedComponent,
    ListPassUserComponent,
    ListShopComponent,
    ListProductComponent,
    ListServiceComponent,
    EmployeOfferComponent,
    AppliedUserComponent,
    EmployeOfferPublishedComponent,
    KahpooEmployeOfferComponent,
    EditPassComponent,
    VarianteComponent,
    ErrorMessageEditComponent,
    WaveTransactionsComponent,
    KeysPipe,
    DetailPostComponent,
    AllPromotionsOfferActiveComponent,
    PrivateSpaceComponent,
    CustomerSpaceComponent,
    PostPrivateSpaceComponent,
    VariantPrivateSpaceComponent,
    UsersWithSoldProductsComponent,
    UsersWithSoldProductsDetailsComponent,
    UserNewVersionComponent,
    UpdateSubCategoryComponent,
    DelegationComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    IconModule,
    IconSetModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    NgImageFullscreenViewModule,
    AngularMultiSelectModule,
    ModalModule,
    NgxDatatableModule,
    CKEditorModule,
    NgxPaginationModule,
    MatSnackBarModule,
    ClipboardModule,
  ],
  exports:[

  ],
  providers: [
    BsModalService,
    UrlService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
    { provide: LOCALE_ID, useValue: 'fr-FR'},
    IconSetService,
    DatePipe
  ],
  bootstrap: [ AppComponent ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
  constructor() {
    registerLocaleData(fr.default);

  }
}
